export default "__VITE_ASSET__C93_j4e5__"